(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6089],{

/***/ 66089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52257);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(145);
/* harmony import */ var ab_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(276);
/* harmony import */ var ab_tag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13703);
/* harmony import */ var react_in_viewport__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28447);
/* harmony import */ var _ab_home_bodega_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87577);
/* harmony import */ var _ab_home_bodega_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_ab_home_bodega_scss__WEBPACK_IMPORTED_MODULE_8__);









var HomeBodega = function(param) {
    var imagencentro = param.imagencentro, imagenizquierda = param.imagenizquierda, imagenderecha = param.imagenderecha, title = param.title, description = param.description, tag = param.tag, _className = param.className, className = _className === void 0 ? "" : _className, _classname = param.classname, classname = _classname === void 0 ? "" : _classname, animated = param.animated, links = param.links, i18n = param.i18n;
    var myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    var ref = (0,react_in_viewport__WEBPACK_IMPORTED_MODULE_7__/* .useInViewport */ .NM)(myRef, {}, {
        onEnterViewport: function() {
        // console.log("entered viewport");
        }
    }, {
        disconnectOnLeave: false
    }), inViewport = ref.inViewport, enterCount = ref.enterCount, leaveCount = ref.leaveCount;
    // console.log('HomeBodega', description, links);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-home-bodega left ".concat(className || classname || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "details",
                children: [
                    tag ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_tag__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: tag
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        element: "h2",
                        animated: animated,
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "images ".concat(inViewport ? "in-viewport" : ""),
                ref: myRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "image-left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: (imagenizquierda === null || imagenizquierda === void 0 ? void 0 : imagenizquierda.mediaItemUrl) || "/images/404.png",
                            alt: "Botella",
                            width: 148,
                            height: 600
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "image-right",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: (imagenderecha === null || imagenderecha === void 0 ? void 0 : imagenderecha.mediaItemUrl) || "/images/404.png",
                            alt: "Botella",
                            width: 148,
                            height: 600
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "image-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: (imagencentro === null || imagencentro === void 0 ? void 0 : imagencentro.mediaItemUrl) || "/images/404.png",
                            alt: "Botella",
                            width: 155,
                            height: 626
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "right",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        element: "div",
                        children: description
                    }),
                    links && links.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row web",
                        children: links.map(function(itm) {
                            var ref, ref1, ref2, ref3;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                prefetch: false,
                                text: itm === null || itm === void 0 ? void 0 : (ref = itm.link) === null || ref === void 0 ? void 0 : ref.title,
                                href: itm === null || itm === void 0 ? void 0 : (ref1 = itm.link) === null || ref1 === void 0 ? void 0 : ref1.url,
                                target: itm === null || itm === void 0 ? void 0 : (ref2 = itm.link) === null || ref2 === void 0 ? void 0 : ref2.target,
                                className: "link"
                            }, itm === null || itm === void 0 ? void 0 : (ref3 = itm.link) === null || ref3 === void 0 ? void 0 : ref3.url);
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mobile",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            prefetch: false,
                            text: t("descubre-nuestra-bodega"),
                            href: t("/tienda"),
                            className: "link"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HomeBodega);


/***/ }),

/***/ 13703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ab_tag_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40050);
/* harmony import */ var _ab_tag_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ab_tag_scss__WEBPACK_IMPORTED_MODULE_1__);


var Tag = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "ab-tag",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tag);


/***/ }),

/***/ 87577:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40050:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);